import { types } from 'mobx-state-tree';

import {
    YearsAtMostRecentAddressValues,
    OccupyingValues,
    HowManyMortgagesValues,
    PropertyTypeValues,
    PropertyPurposeValues,
} from '../definitions/InsCommon';
import Address from './Address';


export default types
    .model('PropertyModel', {
        address: Address,
        yearsAtMostRecentAddress: types.maybeNull(types.enumeration(
            Object.values(YearsAtMostRecentAddressValues),
        )),
        propertyPurpose: types.maybeNull(types.enumeration(
            Object.values(PropertyPurposeValues),
        )),
        propertyType: types.maybeNull(types.enumeration(
            Object.values(PropertyTypeValues),
        )),
        occupying: types.maybeNull(types.enumeration(
            Object.values(OccupyingValues),
        )),
        howManyMortgages: types.maybeNull(types.enumeration(
            Object.values(HowManyMortgagesValues),
        )),
    }).views(self => ({
        get isValid() {
            return self.yearsAtMostRecentAddress != null
                && self.propertyPurpose != null
                && self.propertyType != null
                && self.occupying != null
                && self.howManyMortgages != null
                && self.address.isComplete;
        },
    }));
